<template>
	<div class="box vh-140">
		<div class="box-header">
			<i class="fa fa-th-large"></i>
			<h3 class="box-title">模型分类列表</h3>
			<div class="box-tools">
				<el-button type="primary" size="small" class="pull-right" @click="saveCategory()" round> <i class="fa fa-plus"></i> 添加 </el-button>
			</div>
		</div>
		<div class="box-body">
			<el-table	ref="multipleTable" :data="cateList" border	tooltip-effect="dark"	row-key="id" :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
        <template slot="empty">
          <div class="no-data">暂无数据！</div>
        </template>
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column type="index" label="序号" width="88"></el-table-column>
				<el-table-column prop="name" label="名称" width="250"></el-table-column>
				<el-table-column prop="post" label="岗位" min-width="300">
					<template slot-scope="scope">
						<el-tag type="" effect="plain" size="small" v-for="tag in scope.row.posts" :key="tag" style="margin-right: 5px;" >
							{{tag.name}}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column fixed="right" label="操作" min-width="100">
					<template slot-scope="scope">
            <el-button type="text" @click ="saveCategory(scope.row.id)" size="small"><i class="fa fa-edit"></i> 编辑</el-button>
            <el-button type="text" @click="deleteCategory(scope.row.id)" size="small"><i class="fa fa-trash"></i> 删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

    <model-category-save :visible="addDialog" :echo-id="echoId" @done="handleFinish"></model-category-save>
	</div>
</template>

<script>
import { fetchAll, remove } from '@/api/rep/category'
import ModelCategorySave from './save'
import { handleConfirm } from '@utils/confirm'

export default {
	created() {
		this.fetchData()
	},
  components: {ModelCategorySave},
  data: function() {
    return {
      addDialog:false,
      echoId:null,
      cateList: []
    }
  },
	methods: {
		fetchData() {
			fetchAll().then(resp => {
				this.cateList = resp.data.result
			})
		},
		saveCategory(val) {
		  this.addDialog = true
      this.echoId = val
		},
    handleFinish(flag = false){
		  this.addDialog = false
		  if(flag){
		    this.fetchData()
      }
    },
    deleteCategory(id){
      handleConfirm('此操作将永久删除该分类及其子类吗, 是否继续?').then(() => {
        remove(id).then(resp => {
          this.$message.success(resp.data.message);
          this.fetchData();
        })
      })
    },
	}

}
</script>

<style scoped></style>
